module.exports = __webpack_public_path__ + "img/logo_loading.181ddb2c.png";